import React from "react";
import { FaHandPointLeft } from "react-icons/fa";
import { RouteComponentProps } from "react-router";
import logoImg from "../../../images/logo.png";
import { GoBack, GoBackContainer, Logo, NotFoundContainer } from "./NotFound.styles";

export const NotFound: React.FC<RouteComponentProps> = ({ history }) => (
  <NotFoundContainer>
    <Logo src={logoImg} />

    <h1>Dear user, the requested page has not been found.</h1>

    <GoBack onClick={history.goBack}>
      <GoBackContainer>
        <FaHandPointLeft />
        <h2>Go back</h2>
      </GoBackContainer>
    </GoBack>
  </NotFoundContainer>
);
